/**
 * La lingua della console (regola cardine #2: nessun testo nel codice, per le pagine nuove).
 *
 * Parte da quella del browser (italiano se non è una delle nostre). Lo spazio dei nomi si dichiara in ogni pagina
 * (`useTranslation('partner')`): non c'è uno spazio predefinito, perché le pagine vecchie non ne usano.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { RISORSE, LINGUE, type Lingua } from './risorse';

function linguaDelBrowser(): Lingua {
  const richiesta = (typeof navigator !== 'undefined' ? navigator.language : 'it').slice(0, 2).toLowerCase();
  return (LINGUE as readonly string[]).includes(richiesta) ? (richiesta as Lingua) : 'it';
}

void i18n.use(initReactI18next).init({
  resources: RISORSE,
  lng: linguaDelBrowser(),
  fallbackLng: 'it',
  ns: Object.keys(RISORSE.it),
  defaultNS: 'partner',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
